import loadable from '@loadable/component';
import { useFlag } from '@/features/unleash';

interface Props {
  companyName: string;
}

const DeprecatedExtendedIncomeStatement = loadable(
  () =>
    import(
      '../../../Overview/components/Fundamentals/components/DeprecatedExtendedIncomeStatement'
    )
);

const ExtendedIncomeStatement = loadable(
  () => import('../ExtendedIncomeStatement')
);

export const PastSankey = ({ companyName }: Props) => {
  const featureFlag = useFlag({ name: 'mono-historical-sankey' });

  if (featureFlag.flagsReady && featureFlag.enabled) {
    return <ExtendedIncomeStatement companyName={companyName} />;
  }

  return <DeprecatedExtendedIncomeStatement companyName={companyName} />;
};
